import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { amplifyConfig } from './config/amplifyConfig';
import { Toaster } from 'react-hot-toast';
import {
  HiCamera,
  HiCog,
  HiShieldCheck,
  HiLogout,
  HiLockClosed,
  HiUserCircle,
  HiSparkles
} from 'react-icons/hi';
import './App.css';
import YuzTaramaPage from './pages/YuzTaramaPage';
import AdminPanelPage from './pages/AdminPanelPage';
import SuperAdminPage from './pages/SuperAdminPage';
import LoginPage from './pages/LoginPage';
import PasswordResetPage from './pages/PasswordResetPage';
import ChangePasswordModal from './components/ChangePasswordModal';
import { AuthProvider, useAuth } from './context/AuthContext';

// AWS Amplify'ı global olarak yapılandır (Liveness için)
Amplify.configure(amplifyConfig);

function AppContent() {
  const { user, login, logout, isAuthenticated, loading } = useAuth();
  const [currentPage, setCurrentPage] = useState('yuz-tarama');
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  // Loading durumu
  if (loading) {
    return (
      <div className="App">
        <div className="app-loading">
          <div className="spinner-large"></div>
          <p>Yükleniyor...</p>
        </div>
      </div>
    );
  }

  // Giriş yapılmamışsa LoginPage göster
  if (!isAuthenticated) {
    return (
      <>
        <LoginPage onLogin={login} />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: '#fff',
              color: '#333',
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
              borderRadius: '12px',
              padding: '16px',
              fontSize: '14px',
              fontWeight: '500',
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </>
    );
  }

  // Giriş yapılmışsa ana uygulamayı göster
  return (
    <div className="App">
      <header className="App-header">
        <div className="header-container">
          <div className="header-top">
            <div className="header-brand">
              <div className="brand-icon">
                <HiShieldCheck />
              </div>
              <div className="brand-content">
                <h1>Güvenli Yüz Tanıma Sistemi</h1>
                <p className="brand-subtitle">Yapay Zeka Destekli Güvenlik Platformu</p>
              </div>
            </div>
            <div className="header-actions">
              <div className="user-badge">
                <HiUserCircle />
                <span>{user?.name}</span>
              </div>
              <button
                className="btn btn-secondary"
                onClick={() => setShowPasswordModal(true)}
                title="Şifre Değiştir"
              >
                <HiLockClosed />
                <span>Şifre Değiştir</span>
              </button>
              <button
                className="btn btn-danger"
                onClick={logout}
                title="Çıkış Yap"
              >
                <HiLogout />
                <span>Çıkış Yap</span>
              </button>
            </div>
          </div>

          <nav className="nav-tabs">
            <button
              className={`nav-tab ${currentPage === 'yuz-tarama' ? 'active' : ''}`}
              onClick={() => setCurrentPage('yuz-tarama')}
            >
              <HiCamera />
              <span>Yüz Tarama</span>
            </button>
            <button
              className={`nav-tab ${currentPage === 'admin' ? 'active' : ''}`}
              onClick={() => setCurrentPage('admin')}
            >
              <HiCog />
              <span>Admin Panel</span>
            </button>
            {user?.role === 'super_admin' && (
              <button
                className={`nav-tab ${currentPage === 'super-admin' ? 'active' : ''}`}
                onClick={() => setCurrentPage('super-admin')}
              >
                <HiSparkles />
                <span>Super Admin</span>
              </button>
            )}
          </nav>
        </div>
      </header>

      <main className="App-main">
        {currentPage === 'yuz-tarama' && <YuzTaramaPage />}
        {currentPage === 'admin' && <AdminPanelPage />}
        {currentPage === 'super-admin' && user?.role === 'super_admin' && <SuperAdminPage />}
      </main>

      <footer className="App-footer">
        <p>Güvenli Yüz Tanıma Sistemi v2.0 - Yapay Zeka Destekli Yüz Doğrulama</p>
        <p className="footer-tech">Gerçek Zamanlı Canlılık Tespiti ile Güçlendirilmiş</p>
      </footer>

      {showPasswordModal && (
        <ChangePasswordModal
          onClose={() => setShowPasswordModal(false)}
          currentUsername={user?.username}
        />
      )}

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#fff',
            color: '#333',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
            borderRadius: '12px',
            padding: '16px',
            fontSize: '14px',
            fontWeight: '500',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/sifre-sifirla" element={<PasswordResetPage />} />
          <Route path="/*" element={<AppContent />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
